import { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { useGlobal } from "reactn";
import "moment-duration-format";
import Portal from "@ugg/shared/components/common/Portal";
import useOutsideClick from "@ugg/shared/hooks/use-outside-click";

interface ClipsPlaylistModalProps {
  className?: string;
  src: string;
  onOpen?: () => void;
  onClose?: () => void;
  skip?: boolean;
}

export function ClipsPlaylistModal(props: ClipsPlaylistModalProps) {
  const { className, onOpen, onClose, src } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const [mounted, setMounted] = useState(false);
  const [adsCovered, setAdsCovered] = useGlobal("adsCovered");

  useEffect(() => {
    onOpen?.();
    setMounted(true);
    setAdsCovered(true);

    return () => {
      setAdsCovered(false);
    };
  }, [onOpen, setAdsCovered]);

  useOutsideClick(containerRef, () => {
    if (mounted) {
      onClose?.();
    }
  });

  return (
    <Portal dest="modal-portal">
      <div
        ref={containerRef}
        className={classNames(
          `fixed z-[99999999999] top-0 bottom-0 left-0 right-0 
          flex items-center justify-center bg-purple-500 
          bg-opacity-50 transition-[background-color] duration-100`,
          {
            "!bg-opacity-90": mounted,
          },
          className,
        )}
        onClick={onClose}
      >
        <div
          className={classNames("w-[calc(100vw-24px)] max-w-[866px] scale-[.97] transition-[transform] duration-100", {
            "!scale-100": mounted,
          })}
        >
          <div className="relative w-full pt-[56.25%]">
            <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-purple-300">
              <iframe className="w-full h-full" src={src} allow="clipboard-write" allowFullScreen />
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
}
